module.exports = __webpack_public_path__ + "static/1_norsk-6222aaf279135a0b9bb9a891cbac4ccb.png";